import { ref, provide, computed } from 'vue';
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-da4cf920"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-content"
};
const __default__ = {
  name: 'RevenueKanbanManageNew'
};
import { getIncomePermissionMessage } from '@/utils/incomePermission';
import { ENABLE_INCOME_PERMISSION } from '@/views/revenueKanbanManageNew/config';
// 引入子组件
import RevenueHeader from '@/views/revenueKanbanManageNew/components/RevenueHeader.vue';
import EchartsContent from '@/views/revenueKanbanManageNew/components/EchartsContent.vue';
import TableContent from '@/views/revenueKanbanManageNew/components/TableContent.vue';
import IncomePermissionNotice from '@/components/IncomePermissionNotice.vue';
import { CUSTOM_STORE_NAME_KEY, loadCustomStoreNames } from '@/views/revenueKanbanManageNew/hooks/useCustomStoreName';
// 组件引用，用于调用子组件方法
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    enterpriseAccountId: null
  },
  setup(__props) {
    const props = __props;
    /**
     * 整个看板只拉一次自定义商店名映射，provide 给头部下拉按 dbtId 匹配。
     * 图表与表格的自定义名由 purchaseIncome 接口逐行返回 customStoreName，不走这里。
     */
    const customStoreNames = ref({});
    const customStoreNamesReady = loadCustomStoreNames(props.enterpriseAccountId || '').then(map => {
      customStoreNames.value = map;
    });
    provide(CUSTOM_STORE_NAME_KEY, {
      names: customStoreNames,
      ready: customStoreNamesReady
    });
    // 定义子组件实例类型
    const echartRef = ref(null),
      tableRef = ref(null);
    // 两个接口独立鉴权；页面合并去重，保留任一接口返回的无权限信息。
    const permissionMessage = computed(() => {
      var _echartRef$value, _tableRef$value;
      if (!ENABLE_INCOME_PERMISSION) return '';
      return getIncomePermissionMessage([...new Set([...(((_echartRef$value = echartRef.value) === null || _echartRef$value === void 0 ? void 0 : _echartRef$value.permissionState.noPermissionDbtIds) || []), ...(((_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 ? void 0 : _tableRef$value.permissionState.noPermissionDbtIds) || [])])]);
    });
    // 搜索回调函数：当头部搜索条件变化时，更新图表和表格数据
    const returnSearch = obj => {
      var _echartRef$value2, _tableRef$value2;
      (_echartRef$value2 = echartRef.value) === null || _echartRef$value2 === void 0 || _echartRef$value2.getData(obj);
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RevenueHeader, {
        onReturnSearch: returnSearch
      }), _unref(permissionMessage) ? (_openBlock(), _createBlock(IncomePermissionNotice, {
        key: 0,
        class: "page-permission-notice",
        message: _unref(permissionMessage)
      }, null, 8, ["message"])) : _createCommentVNode("", true), _createVNode(EchartsContent, {
        ref_key: "echartRef",
        ref: echartRef
      }, null, 512), _createVNode(TableContent, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});